import moment from "moment";
export const getLast3Months = () => {
  const months = [];
  const currentDate = new Date();
  
  // Generate 3 months including current month and previous 2 months
  for (let i = 0; i < 3; i++) {
    const date = new Date(currentDate);
    date.setMonth(currentDate.getMonth() - i);
    date.setDate(1); // Set to first day of the month for consistency
    
    const monthName = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    
    months.push({
      key: date, // Date object as key
      value: `${monthName}-${year}`, // Formatted string as value
      month: monthName,
      year: year,
      fullDate: moment(new Date(date)).format("YYYY-MM-DD") // Clone the date object
    });
  }
  
  return months;
};
 
